module.exports = __webpack_public_path__ + "img/eb479e1224254930b4e8f782d134903f-1440.45508c60.jpg";